import React, { useEffect, useRef, useState } from "react";
import { Button, Grid, Typography } from "@material-ui/core";

import RotateLeftIcon from "@material-ui/icons/RotateLeft";
import RotateRightIcon from "@material-ui/icons/RotateRight";
import { PhotoConsumer, PhotoProvider } from "react-photo-view";

import "./style.css";

const IdImageView = ({ imageSrc, label = "" }) => {
  const canvasRef = useRef(null);
  const [rotation, setRotation] = useState(0);

  const drawImage = (img, ctx, canvas, angle) => {
    const radians = (angle * Math.PI) / 180;

    const isSideways = angle % 180 !== 0;

    const width = isSideways ? img.height : img.width;
    const height = isSideways ? img.width : img.height;

    canvas.width = width;
    canvas.height = height;

    ctx.clearRect(0, 0, width, height);

    ctx.save();
    ctx.translate(width / 2, height / 2);
    ctx.rotate(radians);

    ctx.drawImage(img, -img.width / 2, -img.height / 2, img.width, img.height);

    ctx.restore();
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    if (ctx instanceof CanvasRenderingContext2D) {
      const img = new Image();
      img.src = imageSrc;

      img.onload = () => {
        drawImage(img, ctx, canvas, rotation);
      };
    }
  }, [rotation]);

  return (
    <Grid item container direction="column" className="id-image-view-container">
      <Grid
        item
        container
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="body2">{label}</Typography>
        <Grid item container xs justifyContent="flex-end" className="gap-x-8">
          <PhotoProvider photoClosable maskClosable>
            <PhotoConsumer src={imageSrc}>
              <i class="fas fa-expand image-action-icon"></i>
            </PhotoConsumer>
          </PhotoProvider>
          <i
            class="bi bi-arrow-counterclockwise image-action-icon"
            onClick={() => setRotation((r) => (r - 90 + 360) % 360)}
          />
          <i
            class="bi bi-arrow-clockwise image-action-icon"
            onClick={() => setRotation((r) => (r + 90) % 360)}
          />
        </Grid>
      </Grid>
      <canvas ref={canvasRef} />
    </Grid>
  );
};

export default IdImageView;
